
import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const SoccerAttributes = ({ apiData }) => {
  if (!apiData) return <div className="text-white">No data available</div>;

  const attributesData = [
    {
      title: 'Mental Attributes',
      img: 'mental.svg',
      positions: (apiData.mental_attributes || []).map(attr => ({
        name: attr.attribute,
        value: attr.percentage
      }))
    },
    {
      title: 'Physical Attributes',
      img: 'Muscle.svg',
      positions: (apiData.physical_attributes || []).map(attr => ({
        name: attr.attribute,
        value: attr.percentage
      }))
    },
    {
      title: 'Technical Attributes',
      img: 'technical.svg',
      positions: (apiData.technical_attributes || []).map(attr => ({
        name: attr.attribute,
        value: attr.percentage
      }))
    },
    {
      title: 'Tactical Attributes',
      img: 'tacticle.svg',
      positions: (apiData.tactical_positional_attributes || []).map(attr => ({
        name: attr.attribute,
        value: attr.percentage
      }))
    },
    {
      title: 'Injuries Attributes',
      img: 'injuries.svg',
      positions: (apiData.most_sensitive_areas || []).map(attr => ({
        name: attr.attribute,
        value: attr.percentage
      }))
    },
    {
      title: 'Others',
      img: 'otherattributes.svg',
      positions: (apiData.other_evaluative_attributes || []).map(attr => ({
        name: attr.attribute,
        value: attr.percentage
      }))
    }
  ];

  const PrevArrow = ({ onClick }) => (
    <button className="bg-[#D9D9D978] rounded-lg px-2 py-2 absolute left-0 top-1/2 z-30" onClick={onClick}>
      &#10094;
    </button>
  );

  const NextArrow = ({ onClick }) => (
    <button className="custom-next bg-[#D9D9D978] rounded-lg px-2 py-2 absolute right-0 top-1/2" onClick={onClick}>
      &#10095;
    </button>
  );

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  const ProgressBar = ({ value, position }) => (
    <div className="mb-4">
      <div className="flex justify-between items-center mb-2">
        <span className="text-gray-300 text-sm">{position}</span>
        <span className="text-white font-bold text-sm">{value}</span>
      </div>
      <div className="w-full h-2 bg-gray-700 rounded-full overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-green-400 via-purple-500 to-purple-600 rounded-full transition-all duration-500"
          style={{ width: `${value}%` }}
        ></div>
      </div>
    </div>
  );

  return (
    <>
      <div className="w-full mx-auto">
        <h1 className="text-white text-2xl font-bold mb-8">Attributes</h1>
        <div className="relative">
          <Slider {...settings} className="attributes-slider">
            {attributesData.map((attribute, index) => (
              <div key={index} className="px-3">
                <div className="bg-[#D9D9D90A] rounded-xl p-7 h-full ">
                  <div className="flex items-center mb-6">
                    <div className="mr-3">
                      <img src={`/assets/others/${attribute.img}`} />
                    </div>
                    <h2 className="text-white font-semibold text-lg">{attribute.title}</h2>
                  </div>
                  <div className="space-y-3 h-[25rem] overflow-y-auto">
                    {attribute.positions.map((position, posIndex) => (
                      <ProgressBar
                        key={posIndex}
                        value={position.value}
                        position={position.name}
                      />
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </>
  );
};

export default SoccerAttributes;